<div class="platform-task-interface">
  @if (taskConfig && pluginReady) {
    <mtm-task-interface-panel
      [config]="taskConfig"
      (viewAllClick)="onViewAll()"
      (linkCopied)="onLinkCopied($event)"
      (subtaskLinkCopied)="onSubtaskLinkCopied($event)"
      (taskCreated)="onPanelTaskCreated($event)">
      @if (driveRightRail.visible()) {
        <mtm-toggle-rail
          mtmTaskHeaderEnd
          class="task-header-rail"
          orientation="horizontal"
          [items]="headerRailItems()"
          (itemSelected)="onHeaderRailItem($event)" />
      }
    </mtm-task-interface-panel>
  } @else {
    <div
      class="d-flex flex-column flex-fill align-items-center justify-content-center py-3"
      role="status"
      aria-label="Loading tasks">
      <mtm-loading-spinner [size]="32"></mtm-loading-spinner>
      <span class="text-muted" [style.font-size]="'0.8rem'">Initializing component...</span>
    </div>
  }
</div>
